import { ETripView } from '@/domain/Activities.domain';
import { MONTH_FORMAT_DATE } from '@/service/constants/dates';
import { useAttractionsStore } from '@/service/state/Attractions/useAttractionsStore';
import { useSearchAvailabilityStore } from '@/service/state/SearchAvailability/useSearchAvailabilityStore';
import { cn } from '@/service/utils/cn';
import { newDateFromString } from '@/service/utils/getDateByTimezone';
import { isPastDay } from '@/service/utils/isPastDay';
import { CalendarDropdown } from '@/ui/common/Dropdowns/CalendarDropdown';
import { DateIcon } from '@/ui/common/Icons/Date';
import { SearchIcon } from '@/ui/common/Icons/Search';
import { format } from 'date-fns';
import { usePathname, useRouter } from 'next/navigation';
import { useState } from 'react';

export const SearchBox = ({ isLightframe }: { isLightframe?: boolean }) => {
    const pathname = usePathname();
    const [showCalendar, setShowCalendar] = useState(false);
    const [pageMonth, setPageMonth] = useState('');
    const { push } = useRouter();

    const tripView = useAttractionsStore((state) => state.tripView);
    const selectDate = useSearchAvailabilityStore((state) => state.selectDate);
    const handleTripViewChange = useAttractionsStore((state) => state.handleTripViewChange);
    const isSearchView = tripView === ETripView.SEARCH_DATE;
    const isPartnerPage = pathname.split('/').length < 3;
    const isDetailsPage = pathname.includes('/details/');

    if ((isSearchView && isPartnerPage) || (!isPartnerPage && !isDetailsPage)) {
        return <div className="w-full"></div>;
    }

    return (
        <>
            <div
                className="tx-medium-regular z-40 ml-3 flex h-8 w-full cursor-pointer justify-between overflow-hidden rounded-3xl bg-white text-gray-2 md:relative md:-top-0.5 md:h-9 xl:w-[200px]"
                onClick={() => setShowCalendar((prev) => !prev)}
            >
                <div className="relative ml-1 flex items-center">
                    <DateIcon className="md:h-7 md:w-7" />
                    <p className="absolute left-6 top-2 mr-1 align-bottom md:static">Search</p>
                    <p
                        className={cn(
                            'mr-1 hidden lg:block',
                            isLightframe && 'md:block lg:hidden xl:block'
                        )}
                    >
                        by date
                    </p>
                </div>
                <div className="min-w-7 z-10 mr-0.5 mt-0.5 flex h-7 w-7 items-center justify-end rounded-3xl bg-brand md:h-8 md:w-8">
                    <SearchIcon className="mb-0.5 h-6 w-6 md:mr-0.5" />
                </div>
            </div>
            {showCalendar && (
                <CalendarDropdown
                    mode="single"
                    isShown={showCalendar}
                    hideWeek={true}
                    showCalendar={() => {}}
                    hideCalendar={() => {
                        setShowCalendar(false);
                        setPageMonth(format(new Date(), MONTH_FORMAT_DATE));
                    }}
                    fromMonth={new Date()}
                    selected={new Date()}
                    month={pageMonth ? newDateFromString(pageMonth) : new Date()}
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    onSelect={(date: Date) => {
                        setShowCalendar(false);
                        handleTripViewChange(ETripView.SEARCH_DATE);
                        selectDate(date);
                        if (isDetailsPage) {
                            push(`/${pathname.split('/')[1]}`);
                        }
                    }}
                    /* onDayMouseEnter={handleDayMouseEnter}
            onDayMouseLeave={handleDayMouseLeave} */
                    disabled={isPastDay}
                    onMonthChange={(newDate) => {
                        setPageMonth(format(newDate, MONTH_FORMAT_DATE));
                    }}
                    dropdownClassName="top-0 md:top-3 z-50"
                />
            )}
        </>
    );
};
